import { render, staticRenderFns } from "./productTask.vue?vue&type=template&id=0040a7f8&scoped=true"
import script from "./productTask.vue?vue&type=script&lang=js"
export * from "./productTask.vue?vue&type=script&lang=js"
import style0 from "./productTask.vue?vue&type=style&index=0&id=0040a7f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0040a7f8",
  null
  
)

export default component.exports